module.exports = __webpack_public_path__ + "img/mic-share-light.28a8e5e9.png";